module.exports = __webpack_public_path__ + "img/kc-kp-logo.7fdc7389.svg";